"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prependUrlWithHttps = void 0;
function prependUrlWithHttps(url) {
    var httpPrefix = /^((http|https):\/\/)/;
    return httpPrefix.test(url) ? url : "https://".concat(url);
}
exports.prependUrlWithHttps = prependUrlWithHttps;
